import { atom } from "jotai";

export const adPayloadAtom = atom({
  campaignName: "",
  companyNames: "",
  campaignType: "",
  pricingModels: "",
  goal: "",
  budget: 100,
  currencyType: "",
  description: "",
  country: "",
  states: "",
  companyDomain: "",
  locations: [],
  targetDays: [],
  targetDevice: [],
  age: [],
  gender: [],
  education: [],
  connectionTypes: [],
  interests: [],
  contexts: [],
  adTitle: "",
  targetCampaign: "",
  dailyamount: "",
  startDate: new Date(),
  endDate: new Date(),
  descriptionAd: "",
  adCreativeTitle: "",
  adCreativeDescription: "",
  adCreativeUrl: "",
  targetUrl: "",
  creativeTitle: "",
  creativeDescription: "",
  creativeUrl: "",
  iconFilename: null,
  imageFilename: null,
  videoFilename: null,
  impression: null,
  cappingImpressions: false,
  campaignImpressionPerTimes: 0,
  campaignImpressionPerHour: 0,
  cappingClicks: false,
  campaignClickPerTimes: 0,
  campaignClickPerHour: 0,
  currency: "USD"
});

export const isRedirectingAfterLoginAtom = atom(false);
